module.exports = __webpack_public_path__ + "img/VM24_1000.4abbd7c1.jpg";